import { React, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, Container } from 'reactstrap';
import * as Icon from 'react-feather';
import colors from '../../theme/colors';
import ComponentCard from '../../layouts/containers/ComponentCard';
import CustomInputGrid from '../../layouts/input/CustomInputGrid';
import DynamicTable from '../../layouts/dynamicTable/DynamicTable';
import Facturacion from '../../components/facturas/Facturacion';
import facturasApiService from '../../services/http/facturasApiService';
import Loader from '../../layouts/loader/Loader';
import ModalAñadir from '../../layouts/modals/ModalAñadir';
import ModalEditar from '../../layouts/modals/ModalEditar';
import logger from '../../services/logger';

const DetallesFactura = () => {
  const isDisabled = true;
  const [data, setData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenEdit, setModalOpenEdit] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const { empresaId, id } = useParams();
  const [formData, setFormData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [inputs, setInputs] = useState([]);
  const [rows, setRows] = useState([]);
  const [rowws, setRowws] = useState([]);

  const [update, setUpdate] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      try {
        const dataClientes = await facturasApiService.cargarDatosFactura({
          headquarter: empresaId,
          id,
        });

        setData(dataClientes);
        setRows(dataClientes.detalles);
        setRowws(dataClientes.relacion);

        setFormData({
          codigo: dataClientes.cliente.codigo || '',
          titular: dataClientes.cliente.titular || '',
          nombre: dataClientes.cliente.nombre || '',
          nif_cif: dataClientes.cliente.documento || '',
          domicilio: dataClientes.cliente.domicilio || '',
          localidad: dataClientes.cliente.localidad || '', // Asigna la localidad directamente
          provincia: dataClientes.cliente.provincia || '', // Asigna la provincia directamente
          tipo_cliente: dataClientes.cliente.tipoCliente || '', // Asigna el tipo de cliente directamente
        });

        // Guarda los datos obtenidos
        const d = [
          {
            name: 'codigo',
            label: 'Código',
            type: 'text',
          },
          {
            name: 'titular',
            label: 'Titular',
            type: 'text',
          },
          {
            name: 'nombre',
            label: 'Nombre',
            type: 'text',
          },
          {
            name: 'nif_cif',
            label: 'NIF/CIF',
            type: 'text',
          },
          {
            name: 'domicilio',
            label: 'Domicilio',
            type: 'text',
          },
          {
            name: 'localidad',
            label: 'Localidad',
            type: 'text',
          },
          {
            name: 'provincia',
            label: 'Provincia',
            type: 'text',
          },
          {
            name: 'tipo_cliente',
            label: 'Tipo de Cliente',
            type: 'text',
          },
        ];
        setInputs(d);
        // Actualiza el estado de los inputFields con los datos
      } catch (error) {
        logger.error('Error fetching data:', error);
        setData([]); // En caso de error
      } finally {
        setIsLoading(false); // Cambia el estado de carga
      }
    };

    fetch();
  }, [empresaId, id, update]);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const headers = ['Num', 'Descripcion', 'Precio', 'Unidades', 'Importe', 'Impuesto', 'Total'];
  const headerss = ['Concepto', 'Estado', 'Forma', 'Id', 'Importe', 'NumRecibo', 'Vencimiento'];
  // Estado para las filas de la tabla

  const handleEdit = (row) => {
    setSelectedRow(row);
    setModalOpenEdit(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const toggleModalEdit = () => {
    setModalOpenEdit(!modalOpenEdit);
  };

  return (
    <>
      {modalOpen && (
        <ModalAñadir
          isOpen={modalOpen}
          toggle={toggleModal}
          empresaId={empresaId}
          idFactura={id}
          update={update}
          setUpdate={setUpdate}
        />
      )}

      {selectedRow && (
        <ModalEditar
          isOpen={modalOpenEdit}
          toggle={toggleModalEdit}
          initialData={selectedRow}
          empresaId={empresaId}
          update={update}
          setUpdate={setUpdate}
          tipoEdicion="factura"
        />
      )}

      <div className="d-flex" style={{ height: '100vh' }}>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <Container>
              <Row className="mb-3 flex-grow-0">
                <Col md="12">
                  <Row className="mb-3">
                    <ComponentCard title="Facturar a" hasButtons>
                      <CustomInputGrid
                        inputs={inputs.map((input) => ({
                          ...input,
                          value: formData[input.name] || '',
                          onChange: handleChange,
                          disabled: isDisabled, // Deshabilita inputs mientras guarda
                        }))}
                      />
                    </ComponentCard>
                  </Row>
                </Col>
              </Row>

              <Row className="mb-3 flex-grow-0">
                <Col md="12">
                  <Row className="mb-3">
                    <Facturacion
                      datosFacturacion={data?.facturacion}
                      update={update}
                      setUpdate={setUpdate}
                      codigo={data?.cliente?.facturas}
                    />
                  </Row>
                </Col>
              </Row>

              <Row className="mb-3 flex-grow-0">
                <ComponentCard title="Detalles de factura">
                  {/* Componente DynamicTable para mostrar la tabla */}
                  <Row className="mb-3">
                    <Col md="12">
                      <button
                        type="button"
                        onClick={toggleModal}
                        style={{
                          display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 14px',
                          fontSize: '0.75rem', fontWeight: 600, borderRadius: '6px',
                          border: `1px solid ${colors.primary}`, backgroundColor: '#fff',
                          color: colors.primary, cursor: 'pointer', transition: 'all 0.15s',
                        }}
                      >
                        <Icon.Plus size={13} />
                        Añadir
                      </button>
                    </Col>
                  </Row>
                  <DynamicTable
                    update={update}
                    setUpdate={setUpdate}
                    headers={headers}
                    rows={rows}
                    onEdit={handleEdit}
                  />
                </ComponentCard>
              </Row>

              <Row className="mb-3 flex-grow-1">
                <ComponentCard title="Relación de recibos emitidos">
                  <Row className="mb-3"></Row>
                  <DynamicTable
                    update={update}
                    setUpdate={setUpdate}
                    headers={headerss}
                    rows={rowws}
                    onEdit={handleEdit}
                    endpoint={1}
                  />
                </ComponentCard>
              </Row>
            </Container>
          </>
        )}
      </div>
    </>
  );
};

export default DetallesFactura;
